// v9 compat packages are API compatible with v8 code
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import "firebase/compat/functions";
import "firebase/compat/app-check";

class FirebaseAuthBackend {
    constructor(firebaseConfig) {
        if (firebaseConfig) {
            // Initialize Firebase
            firebase.initializeApp(firebaseConfig);
            // Expose for admin console usage (callable functions, debugging)
            if (typeof window !== 'undefined') window.firebase = firebase;
            const appCheck = firebase.appCheck();
            appCheck.activate(
                new firebase.appCheck.ReCaptchaEnterpriseProvider("6Lfel1cdAAAAALFdxs2hWbum1F7Xtl2j5Yym31eh"), true);
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    localStorage.setItem("authUser", JSON.stringify(user));
                    user.getIdTokenResult()
                        .then((idTokenResult) => {
                            // Confirm the user is an Admin.
                            localStorage.setItem("isAdmin", idTokenResult.claims.admin ? 'true' : 'false');
                        });
                } else {
                    console.log("destruction session");
                    localStorage.removeItem('authUser');
                    localStorage.removeItem('isAdmin');
                }
            });

        }
    }

    /**
     * Registers the user with given details
     */
    registerUser = (email, password) => {
        return new Promise((resolve, reject) => {
            firebase.auth().createUserWithEmailAndPassword(email, password).then((user) => {
                // eslint-disable-next-line no-redeclare
                var user = firebase.auth().currentUser;
                resolve(user);
            }, (error) => {
                reject(this._handleError(error));
            });
        });
    }

    /**
     * Login user with given details
     */
    loginUser = (email, password) => {
        return new Promise((resolve, reject) => {
            firebase.auth().signInWithEmailAndPassword(email, password).then(async (user) => {
                //Si la connexion marche, on verifie qu'il s'agit bien d'un coach ou admin
                //Si on kill la session
                var token = await firebase.auth().currentUser.getIdTokenResult();
                localStorage.setItem("authClaims", JSON.stringify(token.claims));
                if (token.claims.admin || token.claims.coach) {
                    resolve({ user: user, claims: token.claims });
                } else {
                    this.logout();
                    reject("Access restricted");
                }
            }, (error) => {
                reject(this._handleError(error));
            });
        });
    }

    /**
     * forget Password user with given details
     */
    forgetPassword = (email) => {
        return new Promise((resolve, reject) => {
            firebase.auth().sendPasswordResetEmail(email, { url: window.location.protocol + "//" + window.location.host + "/login" }).then(() => {
                resolve(true);
            }).catch((error) => {
                reject(this._handleError(error));
            })
        });
    }

    /**
     * Logout the user
     */
    logout = () => {
        return new Promise((resolve, reject) => {
            firebase.auth().signOut().then(() => {
                resolve(true);
            }).catch((error) => {
                reject(this._handleError(error));
            })
        });
    }

    setLoggeedInUser = (user) => {
        localStorage.setItem("authUser", JSON.stringify(user));
    }

    /**
     * Returns the authenticated user
     */
    getAuthenticatedUser = () => {
        if (!localStorage.getItem('authUser'))
            return null;
        return JSON.parse(localStorage.getItem('authUser'));
    }

    /**
     * Handle the error
     * @param {*} error 
     */
    _handleError(error) {
        var errorMessage = error.message;
        return errorMessage;
    }
}

let _fireBaseBackend = null;

/**
 * Initilize the backend
 * @param {*} config 
 */
const initFirebaseBackend = (config) => {
    if (!_fireBaseBackend) {
        _fireBaseBackend = new FirebaseAuthBackend(config);
    }
    return _fireBaseBackend;
}


/**
 * Returns the firebase backend
 */
const getFirebaseBackend = () => {
    return _fireBaseBackend;
}

export { initFirebaseBackend, getFirebaseBackend };